// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__yc98b","col":"CardReaderDesc_col__37HvT","label":"CardReaderDesc_label__6cMQh"};